import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
} from "@mui/material";
import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { ProductType } from "../../shared/enums/ProductType";
import { ListObject } from "../../shared/types/ListObject";
import { ProductItem } from "../../shared/types/ProductItem";
import Tools from "./Tools";
import "./ToolsOptional.scss";

interface ToolsOptionalProps {
  isAccordianExpanded: boolean;
  onAccordianClick(): void;
  onListObjectChange(productItem: ListObject): void;
  onProductTypeChange(productType: ProductType): void;
  refToolsItems: RefObject<HTMLDivElement>;
  refToolsProductItemsList: RefObject<HTMLDivElement>;
  selectedToolsProductItems: ProductItem[];
  selectedToolsProductTypes: ProductType[];
}

const ToolsOptional = ({
  isAccordianExpanded = false,
  onAccordianClick,
  onListObjectChange,
  onProductTypeChange,
  refToolsItems,
  refToolsProductItemsList,
  selectedToolsProductItems,
  selectedToolsProductTypes,
}: ToolsOptionalProps) => {
  const { t } = useTranslation(["tools"]);

  return (
    <Accordion elevation={0} expanded={isAccordianExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-tools-content"
        id="panel-tools-header"
        onClick={onAccordianClick}
      >
        <div>
          <div className="toolOptionalHeader">
            <Checkbox checked={isAccordianExpanded} />
            <h3>{t("ourtools")}</h3>
          </div>
          {isAccordianExpanded === true && (
            <div>
              <p className="font">{t("disclamertools")}</p>
            </div>
          )}
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <Tools
          onListObjectChange={onListObjectChange}
          onProductTypeChange={onProductTypeChange}
          refToolsItems={refToolsItems}
          refToolsProductItemsList={refToolsProductItemsList}
          selectedToolsProductItems={selectedToolsProductItems}
          selectedToolsProductTypes={selectedToolsProductTypes}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default ToolsOptional;
